import {FC} from "react";
import {EmployeesDialog} from "../employees/EmployeesDialog";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {selectEmployeesPopupVisible, setEmployeesPopupVisible} from "../../../features/AppStateSlice";

const EmployeesPopup: FC = () => {
    const dispatch = useAppDispatch();
    const isVisible = useAppSelector(selectEmployeesPopupVisible);

    return (
        <EmployeesDialog zIndex={1100} show={isVisible}
                         onClose={() => dispatch(setEmployeesPopupVisible(false))} />
    );
}

export default EmployeesPopup;
